/**
 * Size chart INCHES / CM unit switcher for Broadcast product popup.
 * Source tables are expected in INCHES (Mandira size charts).
 * First column = size labels (not converted).
 * Columns headed UK / EU / US / Size are not converted.
 */
(function () {
  var IN_TO_CM = 2.54;
  var RANGE_RE = /^(\d+(?:\.\d+)?)\s*[-–—]\s*(\d+(?:\.\d+)?)$/;
  var SINGLE_RE = /^(\d+(?:\.\d+)?)$/;
  var SKIP_HEADER_RE = /^(uk|eu|us|size)$/i;

  function formatCm(inches) {
    return (Math.round(parseFloat(inches) * IN_TO_CM * 10) / 10)
      .toFixed(1)
      .replace(/\.0$/, "");
  }

  function formatInches(value) {
    var n = parseFloat(value);
    if (isNaN(n)) return value;
    return Number.isInteger(n) ? String(n) : String(n);
  }

  function isHeaderLike(text) {
    return (
      /[a-zA-Z]/.test(text) && !SINGLE_RE.test(text) && !RANGE_RE.test(text)
    );
  }

  function getSkipColumns(table) {
    var skip = { 0: true };
    var headerRow =
      table.querySelector("thead tr") || table.querySelector("tr");
    if (!headerRow) return skip;

    headerRow.querySelectorAll("th, td").forEach(function (cell, index) {
      var label = (cell.textContent || "").trim();
      if (SKIP_HEADER_RE.test(label)) skip[index] = true;
    });

    return skip;
  }

  function processCell(cell, columnIndex, skipColumns) {
    if (skipColumns[columnIndex]) return;

    var text = (cell.textContent || "").trim();
    if (!text || isHeaderLike(text)) return;
    if (cell.dataset.sizeChartIn) return;

    var rangeMatch = text.match(RANGE_RE);
    if (rangeMatch) {
      cell.dataset.sizeChartIn = rangeMatch[1] + "-" + rangeMatch[2];
      cell.dataset.sizeChartType = "range";
      return;
    }

    var singleMatch = text.match(SINGLE_RE);
    if (!singleMatch) return;

    cell.dataset.sizeChartIn = singleMatch[1];
    cell.dataset.sizeChartType = "single";
  }

  function prepareTables(modal) {
    var tables = modal.querySelectorAll("table");
    tables.forEach(function (table) {
      var skipColumns = getSkipColumns(table);
      table.querySelectorAll("tr").forEach(function (row, rowIndex) {
        // Skip pure header row text processing for conversion storage on headers
        var cells = row.querySelectorAll("th, td");
        var isLikelyHeader =
          rowIndex === 0 ||
          (row.parentElement && row.parentElement.tagName === "THEAD");

        cells.forEach(function (cell, index) {
          if (isLikelyHeader && isHeaderLike((cell.textContent || "").trim()))
            return;
          processCell(cell, index, skipColumns);
        });
      });
    });
    return tables.length > 0;
  }

  function updateUnitLabels(modal, unit) {
    var label = unit === "cm" ? "(in cm)" : "(in inches)";

    modal.querySelectorAll("[data-size-chart-unit-label]").forEach(function (el) {
      el.textContent = label;
    });

    // Also update pasted "(in inches)" / "(in cm)" text without the attribute
    modal.querySelectorAll("p, em, span").forEach(function (el) {
      if (el.hasAttribute("data-size-chart-unit-label")) return;
      if (el.children.length > 0) return;
      var text = (el.textContent || "").trim();
      if (!/^\(in\s*(inches|cm|centimetres|centimeters)\)$/i.test(text)) return;
      el.setAttribute("data-size-chart-unit-label", "");
      el.textContent = label;
    });
  }

  function applyUnit(modal, unit) {
    modal.querySelectorAll("[data-size-chart-in]").forEach(function (cell) {
      var raw = cell.dataset.sizeChartIn;
      var type = cell.dataset.sizeChartType;

      if (unit === "in") {
        if (type === "range") {
          var inParts = raw.split("-");
          cell.textContent =
            formatInches(inParts[0]) + "–" + formatInches(inParts[1]);
        } else {
          cell.textContent = formatInches(raw);
        }
        return;
      }

      // CM
      if (type === "range") {
        var cmParts = raw.split("-");
        cell.textContent = formatCm(cmParts[0]) + "–" + formatCm(cmParts[1]);
      } else {
        cell.textContent = formatCm(raw);
      }
    });

    updateUnitLabels(modal, unit);

    modal.querySelectorAll("[data-size-chart-unit]").forEach(function (btn) {
      var active = btn.getAttribute("data-size-chart-unit") === unit;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });

    modal.dataset.sizeChartUnit = unit;
  }

  function buildToggle(modal) {
    if (modal.querySelector(".size-chart-unit-toggle")) return;

    var toggle = document.createElement("div");
    toggle.className = "size-chart-unit-toggle";
    toggle.setAttribute("role", "group");
    toggle.setAttribute("aria-label", "Measurement units");
    toggle.innerHTML =
      '<button type="button" class="size-chart-unit-toggle__btn is-active" data-size-chart-unit="in" aria-pressed="true">Inches</button>' +
      '<button type="button" class="size-chart-unit-toggle__btn" data-size-chart-unit="cm" aria-pressed="false">CM</button>';

    toggle.addEventListener("click", function (event) {
      var btn = event.target.closest("[data-size-chart-unit]");
      if (!btn) return;
      applyUnit(modal, btn.getAttribute("data-size-chart-unit"));
    });

    var content =
      modal.querySelector("[data-size-chart-content]") ||
      modal.querySelector(".product-modal__content");
    if (!content) return;

    // Keep switch above chart titles / unit labels
    content.insertBefore(toggle, content.firstChild);
  }

  function enhanceModal(modal) {
    if (!modal || modal.dataset.sizeChartEnhanced === "true") return;

    var hasTables = prepareTables(modal);
    if (!hasTables) return;

    modal.dataset.sizeChartEnhanced = "true";
    buildToggle(modal);
    applyUnit(modal, "in");
  }

  function enhanceAll() {
    document.querySelectorAll("[data-size-chart-modal]").forEach(enhanceModal);
  }

  function onPopupOpen(event) {
    var trigger = event.target.closest("[data-popup-open]");
    if (!trigger) return;
    var popup = trigger.closest("popup-component");
    if (!popup) return;
    var modal = popup.querySelector("[data-size-chart-modal]");
    if (!modal) return;
    window.setTimeout(function () {
      enhanceModal(modal);
    }, 0);
  }

  document.addEventListener("click", onPopupOpen, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enhanceAll);
  } else {
    enhanceAll();
  }

  document.addEventListener("shopify:section:load", enhanceAll);
})();
